import { QueryKeys } from '../../../utils/queryKeyGenerator'
import { handlePatchRequest } from '../../../utils/api-handler.util'
import { showToaster } from '../../../utils/show-toaster.util'
import USER_TYPE from '../../../constants/userType'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import ConfirmModal from '../../common/ConfirmModal'

export default function ShopActionButtons({ shop, onSuspendClick }) {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const { userType, shopSlug, shopName } = shop

  const unSuspendMutation = useMutation({
    mutationFn: () => {
      handlePatchRequest(`/admin/${userType}s/${shop.userId}/unsuspend`)
    },
    onSuccess: () => {
      if (userType === USER_TYPE.retailer) {
        QueryKeys.adminRetailerDetails.invalidate(shopSlug)
        QueryKeys.adminListRetailers.invalidateAll()
      } else {
        QueryKeys.adminWholesellerDetails.invalidate(shopSlug)
        QueryKeys.adminListWholesellers.invalidateAll()
      }
      showToaster('success', ` Unsuspended ${userType} ${shopName} successfully`)
    },
    onError: () => {
      showToaster('error', `Error unsuspending ${userType} ${shopName} `)
    },
  })
  const isConfirming = unSuspendMutation.isPending

  const handleUnsuspendConfirm = async () => {
    unSuspendMutation.mutateAsync()
  }

  return (
    <>
      {shop?.user?.isActive ? (
        <button
          onClick={onSuspendClick}
          className="bg-red-600 text-white px-4 py-2 text-sm rounded-md hover:bg-red-700 transition-colors"
        >
          Suspend
        </button>
      ) : (
        <button
          onClick={() => setShowConfirmationModal(true)}
          className="bg-green-600 text-white px-4 py-2 text-sm rounded-md hover:bg-green-700 transition-colors"
        >
          Unsuspend
        </button>
      )}
      <ConfirmModal
        isOpen={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        onConfirm={handleUnsuspendConfirm}
        title={'Unsuspend Shop'}
        message={`Are you sure you want to unsuspend ${shop.shopName}?`}
        confirmText={isConfirming ? 'UnSuspending...' : 'Confirm UnSuspend'}
        cancelText="Go Back"
        isConfirming={isConfirming}
      />
    </>
  )
}
